// AlertModal.js
import React from "react";

const AlertModal = ({ type = "success", title, message, onClose }) => {
  // Set up background and text colors and an icon based on the type
  let bgColor, textColor, icon;
  switch (type) {
    case "success":
      bgColor = "bg-green-100";
      textColor = "text-green-800";
      icon = (
        <svg
          className="w-6 h-6 text-green-800"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
        </svg>
      );
      break;
    case "warning":
      bgColor = "bg-yellow-100";
      textColor = "text-yellow-800";
      icon = (
        <svg
          className="w-6 h-6 text-yellow-800"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M12 20.5A8.5 8.5 0 1012 3.5a8.5 8.5 0 000 17z" />
        </svg>
      );
      break;
    case "error":
      bgColor = "bg-red-100";
      textColor = "text-red-800";
      icon = (
        <svg
          className="w-6 h-6 text-red-800"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      );
      break;
    default:
      bgColor = "bg-blue-100";
      textColor = "text-blue-800";
      icon = (
        <svg
          className="w-6 h-6 text-blue-800"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M12 20.5A8.5 8.5 0 1012 3.5a8.5 8.5 0 000 17z" />
        </svg>
      );
      break;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black opacity-50" onClick={onClose}></div>
      {/* Modal */}
      <div className={`relative z-50 ${bgColor} rounded-lg p-6 max-w-md mx-auto`}>
        <div className="flex items-center">
          <div className="mr-3">{icon}</div>
          <div>
            <h3 className={`font-bold text-xl ${textColor}`}>{title}</h3>
            <p className={`mt-2 text-sm ${textColor}`}>{message}</p>
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <button
            onClick={onClose}
            className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded focus:outline-none"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
